import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchClassifications = createAction(constants.FETCH_CLASSIFICATIONS)
export const fetchClassificationsPending = createAction(constants.FETCH_CLASSIFICATIONS_PENDING)
export const fetchClassificationsFailed = createAction(constants.FETCH_CLASSIFICATIONS_FAILED)
export const fetchClassificationsSuccess = createAction(constants.FETCH_CLASSIFICATIONS_SUCCESS)

export const createClassifications = createAction(constants.CREATE_CLASSIFICATIONS)
export const createClassificationsPending = createAction(constants.CREATE_CLASSIFICATIONS_PENDING)
export const createClassificationsFailed = createAction(constants.CREATE_CLASSIFICATIONS_FAILED)
export const createClassificationsSuccess = createAction(constants.CREATE_CLASSIFICATIONS_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/classification/actions.js